import Vue from 'vue'
import Router from 'vue-router'
import defaultRouter from './defaultRouter'
import store from '@/store'
import mroutes from './routes.js'
import sensors from '@/plugin/track'
import { languageExecute } from './utils'
import '@/plugin/aegis'
import { getLoginKey } from '@/utils/cache'
Vue.use(Router)
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch((err) => err)
}

const routerContext = require.context('./modules', true, /\.js$/)

const routerList = []
routerContext.keys().forEach((route) => {
  const routerModule = routerContext(route)
  routerList.push(routerModule.default)
})

export const routeList = [...defaultRouter, ...routerList]

const createRouter = () =>
  new Router({
    mode: 'history',
    routes: routeList,
    scrollBehavior(to, _from, savedPosition) {
      const whitelist = ['LogisticsList']
      if (!whitelist.includes(to.name)) {
        if (savedPosition) return savedPosition
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve({ x: 0, y: 0 })
          }, 200)
        })
      }
    }
  })

const router = createRouter()

router.beforeEach(async(_to, _from, next) => {
  if(_to.path === '/') {
    return window.location.reload()
  }

  languageExecute()
  // MINE: 本地调试 token 校验
  if (getLoginKey()) {
    await store.dispatch('user/getUserInfo')
  }
  if (
    /Android|webOS| iPhone | iPad | iPod |BlackBerry|opera mini|opera mobile|appleWebkit.*mobile|mobile/i.test(
      navigator.userAgent
    ) &&
mroutes[_to.name] &&
mroutes[_to.name](_to.query)
  ) {
    window.location.href = `${process.env.VUE_APP_MOBILE_DOMAIN}/${mroutes[_to.name](_to.query)}`
  } else {
    if (!store.getters['market/marketList'].length && _to.name !== 'ProductList') { await store.dispatch('market/getMarkets') }
    const cancelArr = window.axiosCancel || []
    cancelArr.forEach((ele, index) => {
      ele.cancel('取消了请求') // 在失败函数中返回这里自定义的错误信息
      delete window.axiosCancel[index]
    })
  }
  setTimeout(function() {
    // console.log('url2:', document.URL);

    next()
    // console.log('to:', to, 'from:', from, 'URL:', document.URL);
    sensors.quick('autoTrackSinglePage') // after the next(); statement
  }, 0)

  next()
})

export default router
